import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

//components
import Head from 'components/common/Head/Head';
//assets
import errorIllustration from 'assets/illustrations/404.svg';
//styles
import { ErrorContainer, Email, Header, Message } from '../ErrorPages.styled';
import { DefaultButton } from 'components/styled/Button';

export const ErrorScreen = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [counter, setCounter] = useState(10);

  useEffect(() => {
    if (counter <= 0) {
      navigate('/accommodations/dashboard');

      return;
    }

    const timer = setInterval(() => setCounter(counter - 1), 1000);

    return () => clearInterval(timer);
  }, [navigate, counter]);

  return (
    <ErrorContainer>
      <Head title={t('Something went wrong')} />
      <img src={errorIllustration} alt="404 Error" />

      <Header>{t('Something went wrong')}</Header>
      <Message>
        {t('Please try refreshing the page or contact us on')}
        <Email href="mailto: info@travelsoft.hr">info@travelsoft.hr</Email>
      </Message>
      <Message>{t('redirectingOnDashboardInCounter', { counter: counter })}</Message>
      <Link to={'/accommodations/dashboard'}>
        <DefaultButton type="button" width="7.5rem" color="white" margin="4rem 0 0 0">
          {t('Refresh')}
        </DefaultButton>
      </Link>
    </ErrorContainer>
  );
};
